"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacteristicValueSchema = void 0;
const zod_1 = require("zod");
const AbsoluteCharacteristicValueBase_1 = require("./AbsoluteCharacteristicValueBase");
exports.CharacteristicValueSchema = AbsoluteCharacteristicValueBase_1.AbsoluteCharacteristicValueBaseSchema.extend({
    relativeToNet: zod_1.default.string().optional(),
});
//# sourceMappingURL=CharacteristicValue.js.map